import React, { useMemo, useState } from 'react';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { observer } from 'mobx-react';
import { Switch } from '@chakra-ui/react';
import { ConfirmModal } from 'components';

type FeatureKey = 'cadDiff';

type FeatureSwithersProps = {
  featureFlags: Record<FeatureKey, boolean>;
  onUpdateFeatureFlags: any;
} & WithNamespaces;

type KeyConfig = {
  confirmText: string;
  checkoutText: string;
};

// - TODO: Swithers?
export const FeatureSwithers = withNamespaces()(
  observer(({ featureFlags, onUpdateFeatureFlags }: FeatureSwithersProps) => {
    const [operatorKey, setOperatorKey] = useState<FeatureKey>(null);
    const [loading, setLoading] = useState(false);

    const flagKeyConfig: Record<FeatureKey, KeyConfig> = {
      cadDiff: {
        confirmText: 'CAD Diff and Measurement',
        checkoutText: 'CAD Diff',
      },
      hidden: {
        confirmText: 'Hide Initiative from Team card dropdown',
        checkoutText: 'Hide Initiative',
      }
    };

    const isEnabledForFlagKey = operatorKey && featureFlags[operatorKey];
    const { confirmText } = flagKeyConfig[operatorKey] || {};

    const confirmMessage = isEnabledForFlagKey
      ? `You are about to disable ${confirmText} for this customer.`
      : `You are about to enable ${confirmText} for this customer.`;

    const renderSwithers: string[] = useMemo(() => {
      return Object.keys(flagKeyConfig);
    }, [flagKeyConfig]);

    return (
      <>
        {renderSwithers.map(key => {
          return (
            <Switch
              key={key}
              isChecked={featureFlags[key]}
              onChange={() => {
                setOperatorKey(key);
              }}
              className='gap-4 text-black flex items-center flex-nowrap'
            >
              {`${flagKeyConfig[key].checkoutText} ${
                featureFlags[key] ? 'Enabled' : 'Disabled'
              }`}
            </Switch>
          );
        })}
        <ConfirmModal
          open={!!operatorKey}
          titleClassName='font-normal text-center text-base justify-center w-fit whitespace-nowrap'
          titleStyle={{
            fontSize: 16,
          }}
          contentProps={{
            sx: {
              maxWidth: 'unset',
            },
          }}
          title={confirmMessage}
          loading={loading}
          onConfirm={() => {
            setLoading(true);
            onUpdateFeatureFlags({
              key: operatorKey,
              value: !isEnabledForFlagKey,
              onSuccess: () => {
                setLoading(false);
                setOperatorKey(null);
              },
            });
          }}
          onClose={() => {
            setLoading(false);
            setOperatorKey(null);
          }}
        />
      </>
    );
  }),
);
